import { Component, OnDestroy, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ActionItemRendererParams, CustomDropdownSelection } from '../interfaces/ag-grid-cell-renderer.interface';

export interface CustomDropdownParams extends ActionItemRendererParams{
  customDropdownSelections: CustomDropdownSelection[];
}

@Component({
  selector: 'app-ag-custom-dropdown-cell-renderer',
  templateUrl: './ag-custom-dropdown-cell-renderer.component.html',
  styleUrls: ['./ag-custom-dropdown-cell-renderer.component.scss'],
  standalone: false,
})
export class AgCustomDropdownCellRendererComponent implements ICellRendererAngularComp, OnInit {
  private params: CustomDropdownParams;
  
  selection: any;
  isEditing: boolean = false;

  ngOnInit(): void {}

  agInit(params: CustomDropdownParams): void {
    this.params = params;
    this.selection = this.params.customDropdownSelections[0];
    this.refresh(params);
  }

  refresh(params: CustomDropdownParams): boolean {
    this.params = params;
    this.selection = params.customDropdownSelections.find(selection => selection.value === params.value);
    return false;
  }

  ngOnDestroy(): void {}
}

